<template>
    <div class="TQ_selectable TQ_width_100p TQ_scrollable">
        <keep-alive>
            <router-view />
        </keep-alive>
    </div>
</template>

<script>
    import {store_var, store_getStateValue_vo, store_setStateValue} from "../store";
    import {
        enum_accessLevel_byAccessName
    } from "../../functions/src/shareCode/Share_S_Enum";
    import {serverAuth_currentUserData_get_vl_fp} from "../scripts/Server/S_ServerAuth";
    import {route_moveToRoute} from "../router";
    import {enum_moveToOptions} from "../../functions/src/shareCode/Share_S_Enum";
    import {ass_navTabs} from "../assets/scripts/Ass_NavTabs";

    export default {
        name: "v_Admin",
        data(){
            return {
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),
            }
        },
        methods:{
            m_mounted_userHaveAdminPermission_b(){
                // 1) user exist
                if(!this.server_currentUserData_c){
                    return false
                }

                // 2) user permission
                else if(this.server_currentUserData_c.ud_accessLevel_n < enum_accessLevel_byAccessName.route_admin){
                    return false
                }

                return true
            }
        },
        created(){

            store_setStateValue(store_var.navBar_tabs_ac, [ass_navTabs.admin_quests, ass_navTabs.admin_users, ass_navTabs.admin_events, ass_navTabs.admin_tickets, ass_navTabs.admin_reports, ass_navTabs.admin_blog, ass_navTabs.admin_coupons, ass_navTabs.admin_errors])
        },
        mounted(){

            // get current user data
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData) => {

                if(currentUserData == null){
                    return
                }

                this.server_currentUserData_c = currentUserData;


                if(!this.m_mounted_userHaveAdminPermission_b()){
                    route_moveToRoute(enum_moveToOptions.player_profile)
                }

            })
        },
    }
</script>

<style scoped>

</style>